import type { MatomoPayload } from './types'

type Paq = { push: (event: unknown[]) => void }

function getPaq(): Paq | null {
  const g = globalThis as any
  const paq = g._paq
  if (paq && typeof paq.push === 'function') {
    return paq as Paq
  }
  return null
}

export function matomoPush(args: unknown[]): void {
  const paq = getPaq()
  if (!paq) return
  paq.push(args)
}

/**
 * Matomo trackEvent signature:
 * ['trackEvent', category, action, name, value?, customData?]
 *
 * We set `value` to false to skip it and ensure payload is passed as customData.
 */
export function matomoTrackEvent(
  category: string,
  action: string,
  name: string,
  payload: MatomoPayload = {},
): void {
  matomoPush(['trackEvent', category, action, name, false, payload])
}
